export const MaldivesImages ={
    d1 : require('./mport1.jpg').default,
    d2 : require('./mport2.jpg').default,
    db1 : require('./mbeach1.jpg').default,
    db2 : require('./mbeach2.jpg').default,
    dh1 : require('./mhotels1.jpg').default,
    dh2 : require('./mhotels2.jpg').default,
    dp1 : require('./mpack1.jpg').default,
    dp2 : require('./mpack2.jpg').default,
    dp3 : require('./mpack3.jpg').default,
    dp4 : require('./mpack4.jpg').default,
    do1 : require('./monly1.jpg').default,
    do2 : require('./monly2.jpg').default,
}